import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import EmergencyManagementDetails from '../mendepartmentdetails/EmergencyManagement'


function EmergencyManagement() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Emergency Management || State of GTS";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="home"
            title="Emergency Management"
            subtitledown="Department of Emergency Management"
           />
            <EmergencyManagementDetails/>
        </div>
    </>
  )
}

export default EmergencyManagement